import React from "react";

const txt = "How can I link a publication to a variant?";
const varsUrl = "https://docs.varsome.com/en/contributing-to-varsome";

function HowToArticleLink() {
  return (
    <div className="tw-flex tw-items-center">
      <div className="tw-px-1">
        <i
          data-tooltip={txt}
          className="fa fa-question-circle tw-text-blue-400"
        />
      </div>
      <a href={varsUrl} target="_blank">
        How to link publications
      </a>
    </div>
  );
}

export default React.memo(HowToArticleLink);
